import { AnyAction } from 'redux';

import { Customer } from '../models/customer';
import {
    RECEIVE_QUICKSEARCH_RESULT,
    REQUEST_QUICKSEARCH,
    REQUEST_QUICKSEARCH_COMPLETE,
    RESET_QUICKSEARCH,
} from '../actions/quick-search-actions';

export interface QuickSearchReducerState {
    flat: Customer[];
    inProgress: boolean;
}

const initialQuickSearchReducerState: QuickSearchReducerState = {
    flat: [],
    inProgress: false,
};

export const quickSearchReducer = (
    state: QuickSearchReducerState = initialQuickSearchReducerState,
    action: AnyAction
): QuickSearchReducerState => {
    const { type } = action;
    switch (type) {
        case REQUEST_QUICKSEARCH: {
            return {
                ...state,
                inProgress: true,
            };
        }

        case REQUEST_QUICKSEARCH_COMPLETE: {
            return {
                ...state,
                inProgress: false,
            };
        }

        case RECEIVE_QUICKSEARCH_RESULT: {
            return {
                ...state,
                flat: action['customers'],
            };
        }

        case RESET_QUICKSEARCH: {
            return { ...initialQuickSearchReducerState };
        }

        default: {
            return state;
        }
    }
};
